import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewUserPageNew from "../../components/User/ViewUserPageNew";
import SubscriptionsViewPage from "../../components/subscription.jsx/ViewSubscriptionPage";



const ViewSubscriptionsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb  id="title" title2="Subscriptions" link2="/subscriptions" title="View Subscription" />
        <SubscriptionsViewPage/>
      </MasterLayout>
    </>
  );
};

export default ViewSubscriptionsPage;
